import { ThrowStmt } from '@angular/compiler';
import { TranslationServiceHelper } from '../lib/translation.service';
import { UtilityService } from 'app/lib/utility.service';

export class Course {
    id: number;
    key: string;
    label: string;
    category: number;
    courseTitle: string;
    description: string;
    isCompleted: boolean;
    created: Date;
    length: string;
    default: boolean;
    active: boolean;
    talkAboutDescription: string;
    talkAboutLink: string;
    chapters: Chapter[] = [];
    courseImage: fileUpload;
    videos: Video[] = [];
    courseName: string;

    public static initializeArray(objects: any): Course[] {
        let results: Course[] = [];
        for (let i = 0; i < objects.length; i++) {
            let obj = new Course(objects[i][0]);
            results.push(obj);
        }

        return results;
    }

    constructor(data: any) {
        if (data) {
            this.id = data.ID || data.id;
            this.courseTitle = data.CourseTitle || data.courseTitle;
            this.label = data.label || data.Label;
            this.category = data.Category || data.category;
            this.key = data.key || data.Key;
            this.length = data.length || data.Length;
            this.description = data.Description || data.description;
            this.default =
                data.Default ||
                data.default ||
                data.DefaultCourse ||
                data.defaultCourse;
            this.active = data.Active || data.active;
            this.isCompleted = data.IsCompleted || data.iscompleted || false;
            this.talkAboutDescription =
                data.TalkAboutDescription || data.talkAboutDescription;
            this.talkAboutLink = data.TalkAboutLink || data.talkAboutLink;
            this.created = data.createdOnUtc || data.CreatedOnUtc;
            this.courseImage = new fileUpload(
                data.CourseImage || data.courseImage
            );
            this.courseName = data.CourseName;
        }
        this.initializeChapters(data.chapters || data.Chapters || []);
        this.initializeVideos(data.videos || data.Videos || []);
    }

    public initializeChapters(chapters?: any) {
        if (chapters) {
            for (let i = 0; i < chapters.length; i++) {
                this.chapters.push(new Chapter(chapters[i]));
            }
        } else {
            for (let i = 0; i < 1; i++) {
                this.chapters.push(new Chapter());
            }
        }
    }
    public initializeVideos(videos?: any) {
        if (videos) {
            for (let i = 0; i < videos.length; i++) {
                this.videos.push(new Video(videos[i]));
            }
        } else {
            for (let i = 0; i < 1; i++) {
                this.videos.push(new Video());
            }
        }
    }

    public static forAPI(course: Course) {
        return {
            ID: course.id,
            Label: course.label,
            Key: course.key,
            Category: course.category,
            Description: course.description,
            DefaultCourse: course.default,
            Active: course.active,
            Length: course.length,
            TalkAboutDescription: course.talkAboutDescription,
            Chapters: course.chapters,
            CourseImage: course.courseImage,
        };
    }
}

export class AudioCourse {
    id: number;
    authoren: string;
    authorfr: string;
    authores: string;
    titleen: string;
    titlefr: string;
    titlees: string;
    category: number;
    transcripten: string;
    transcriptfr: string;
    transcriptes: string;
    isCompleted: boolean;
    created: Date;
    default: boolean;
    active: boolean;
    audio: fileUpload;
    image: fileUpload;
    audioURL: string;
    imageURL: string;
    quotesen: string;
    quoteses: string;
    quotesfr: string;
    categoryid: number;
    categorytitle: string;
    // question: string;
    // counselorname: string;

    public static initializeArray(objects: any): AudioCourse[] {
        let results: AudioCourse[] = [];
        for (let i = 0; i < objects.length; i++) {
            let obj = new AudioCourse(objects[i][0]);
            results.push(obj);
        }

        return results;
    }

    constructor(data: any) {
        if (data) {
            this.id = data.ID || data.id;
            this.titleen = data.titleen || data.Title_en;
            this.titlefr = data.titlefr || data.Title_fr;
            this.titlees = data.titlees || data.Title_es;
            // this.question = data.question || data.Question;
            // this.counselorname = data.counselorname || data.counselorName;
            this.category = data.Category || data.category;
            this.authoren = data.authoren || data.Author_en;
            this.authorfr = data.authorfr || data.Author_fr;
            this.authores = data.authores || data.Author_es;
            this.transcripten = data.transcripten || data.Transcript_en;
            this.transcriptfr = data.transcriptfr || data.Transcript_fr;
            this.transcriptes = data.transcriptes || data.Transcript_es;
            this.default = data.Default || data.default;
            this.active = data.Active || data.active;
            this.isCompleted = data.IsCompleted || data.iscompleted || false;
            this.created = data.createdOnUtc || data.CreatedOnUtc;
            this.audio = new fileUpload(data.audio || data.Audio);
            this.image = new fileUpload(data.Image || data.image);
            this.audioURL = data.AudioUrl || data.audioUrl;
            this.imageURL = data.ImageUrl || data.imageUrl;
            this.quotesen = data.QuoteEn || data.quote_en;
            this.quoteses = data.QuoteEs || data.quote_es;
            this.quotesfr = data.QuoteFr || data.quote_fr;
            this.categoryid = data.CategoryID || data.category_id;
            this.categorytitle = data.Title || data.category_title;
        }
    }

    public static forAPI(course: AudioCourse) {
        return {
            ID: course.id,
            Labelen: course.titleen,
            Labelfr: course.titlefr,
            Labeles: course.titlees,
            Authoren: course.authoren,
            Authorfr: course.authorfr,
            Authores: course.authores,
            Category: course.category,
            Descriptionen: course.transcripten,
            Descriptionfr: course.transcriptfr,
            Descriptiones: course.transcriptes,
            DefaultCourse: course.default,
            Active: course.active,
            AudioFileUpload: course.audio,
            CourseImage: course.image,
        };
    }

    public static forAPIFormData(course: Course) {
        // 	return {
        // 		ID: course.id,
        // 		Label: course.label,
        // 		Key: course.key,
        // 		Length: course.length,
        // 		CourseListing: course.courseListing
        // 	};

        const formData: FormData = new FormData();
        course.id && formData.append('id', course.id.toString());
        formData.append('key', course.key);
        formData.append('category', course.category.toString());
        formData.append('label', course.label);
        formData.append('length', course.length);
        formData.append('talkAboutDescription', course.talkAboutDescription);

        course.chapters.forEach(courseItem => {
            formData.append('courseListing[]', JSON.stringify(courseItem));
        });

        return formData;
    }
}

export class Chapter {
    id: number;
    name: string;
    label: string;
    length: string;
    order: number;
    isActive: number;
    code: string;
    description: string;
    videos: Video[] = [];

    constructor(data?: any) {
        if (data) {
            this.id = data.id || data.ID;
            this.name = data.name || data.Name;
            this.label = data.Label || data.label;
            this.length = data.Length || data.length;
            this.order = data.order || data.Order;
            this.isActive = data.isActive || data.IsActive;
            this.code = data.code || data.Code;
            this.description = data.Description || data.description;
        }
        this.initializeVideos(data.videos || data.Videos || []);
    }

    public initializeVideos(videos?: any) {
        if (videos) {
            for (let i = 0; i < videos.length; i++) {
                this.videos.push(new Video(videos[i]));
            }
        } else {
            for (let i = 0; i < 1; i++) {
                this.videos.push(new Video());
            }
        }
    }
}

export class Video {
    id: number;
    label: string;
    length: string;
    image: string;
    imageUpload: fileUpload;
    media: string;
    mediaUpload: fileUpload;
    captionFile: string;
    captionFileUpload: fileUpload;
    audioFile: string;
    audioFileUpload: fileUpload;
    forceVideo: number;
    isCompleted: boolean;
    description: string;
    attachments: Attachment[] = [];
    links: string[];
    courseProgress: any;
    rating: any;
    videoRating: number = 0;

    constructor(data?: any) {
        if (data) {
            this.id = data.ID || data.id;
            this.label = data.Label || data.label || data.videoTitle;
            this.length = data.Length || data.length || data.videoDuration;
            this.image = data.Image || data.image || data.videoImage;
            this.media = data.Media || data.media || data.videoFile;
            this.captionFile =
                data.CaptionFile || data.captionFile || data.captionfile;
            this.audioFile = data.AudioFile || data.audioFile;
            this.forceVideo = data.ForceVideo || data.forceVideo;
            this.description = data.description || data.Description;
            this.courseProgress = data.courseProgress || {};
            this.rating = data.rating || [];
            if (this.description) {
                this.links = this.initializeLinks();
            }
            this.isCompleted = data.IsCompleted;
            this.imageUpload = new fileUpload(
                data.ImageUpload || data.imageUpload
            );
            this.mediaUpload = new fileUpload(
                data.MediaUpload || data.mediaUpload
            );
            this.captionFileUpload = new fileUpload(
                data.CaptionFileUpload || data.captionFileUpload
            );
            this.audioFileUpload = new fileUpload(
                data.AudioFileUpload || data.audioFileUpload
            );
        } else {
            this.imageUpload = new fileUpload({});
            this.mediaUpload = new fileUpload({});
            this.captionFileUpload = new fileUpload({});
            this.audioFileUpload = new fileUpload({});
        }
        this.initializeAttachments(data.Attachments || data.attachments || []);
    }

    public initializeAttachments(attachments?: any) {
        if (attachments) {
            for (let i = 0; i < attachments.length; i++) {
                this.attachments.push(new Attachment(attachments[i]));
            }
        } else {
            for (let i = 0; i < 1; i++) {
                this.attachments.push(new Attachment());
            }
        }
    }

    public initializeLinks(): any[] {
        let links = [];

        const Token = {
            '[mindfulnessCourse]': {
                link: '/app/series-listing/mindfulness/128',
                label: 'theory.courses.links.mindfulnessCourse',
            },
            '[moodcheckLink]': {
                link: '/app/load/moodcheck',
                label: 'theory.courses.links.moodcheckLink',
            },
            '[zenRoomLink]': {
                link: '/app/practice/zen-room',
                label: 'theory.courses.links.zenRoomLink',
            },
            '[cognitiveThoughtsLink]': {
                link: '/app/practice/cd-quiz',
                label: 'theory.courses.links.cognitiveThoughtsLink',
            },
            '[thoughtDiaryLink]': {
                link: '/app/practice/thoughtdiary',
                label: 'theory.courses.links.thoughtDiaryLink',
            },
            '[activitySchedulerLink]': {
                link: '/app/practice/activityscheduler',
                label: 'theory.courses.links.activitySchedulerLink',
            },
            '[funAchievementLink]': {
                link: '/app/practice/funachievement',
                label: 'theory.courses.links.funAchievementLink',
            },
            '[roomforthePositive]': {
                link: '/app/practice/room-for-positive/listing',
                label: 'theory.courses.links.roomforthePositive',
            },
        };

        const matches = this.description.match(/\[(.*?)\]/g);

        if (matches) {
            matches.forEach(match => {
                if (Token.hasOwnProperty(match)) {
                    Token[match].label =
                        TranslationServiceHelper.translateLabel(
                            Token[match].label
                        );
                    links.push(Token[match]);
                    this.description = this.description.replace(match, '');
                }
            });
        }

        return links;
    }
}

export class AudioFileUpload {
    audioFileUpload: fileUpload;

    constructor(data?: any) {
        if (data) {
            this.audioFileUpload = new fileUpload(
                data.AudioFileUpload || data.audioFileUpload
            );
        } else {
            this.audioFileUpload = new fileUpload({});
        }
    }
}

export class Attachment {
    id: number;
    title: string;
    attachment: string;
    fileUpload: string;
    fileFilename: string;
    filePath: string;
    fileFullPath: string;

    /*
     * Different cases here should go away and we should stick to a standard response
     * for all course data
     */
    constructor(data?: any) {
        if (data) {
            this.id = data.ID || data.id;
            this.title = data.Title || data.title;
            this.attachment = data.Attachment || data.attachment;
            this.filePath = data.FilePath || data.filePath;
            this.fileFullPath = data.FileFullPath || data.FullFilePath;
        }
    }
}

export class fileUpload {
    fileUpload: string;
    fileFilename: string;

    constructor(data: any) {
        if (data) {
            this.fileUpload = data.FileUpload || data.fileUpload;
            this.fileFilename = data.fileFilename || data.fileFilename;
        }
    }
}
export class Daily {
    dailycontents: DailyContent[] = [];

    public static initializeArray(objects: any): Daily[] {
        let results: Daily[] = [];
        for (let i = 0; i < objects.length; i++) {
            let obj = new Daily(objects[i][0]);
            results.push(obj);
        }

        return results;
    }

    constructor(data: any) {
        this.initializeDailyData(data.dailydata || data.dailydata || []);
    }

    public initializeDailyData(dailycontents?: any) {
        if (dailycontents) {
            for (let i = 0; i < dailycontents.length; i++) {
                this.dailycontents.push(new DailyContent(dailycontents[i]));
            }
        } else {
            for (let i = 0; i < 1; i++) {
                this.dailycontents.push(new DailyContent());
            }
        }
    }

    public static forAPI(daily: Daily, grpID: number) {
        return {
            ID: grpID,
            Dailydata: daily.dailycontents,
        };
    }
}
export class DailyContent {
    category: string;
    quotesen: string;
    quoteses: string;
    quotesfr: string;

    constructor(data?: any) {
        if (data) {
            this.category = data.Category || data.category;
            this.quotesen = data.QuoteEn || data.quotesen;
            this.quoteses = data.QuoteEs || data.quoteses;
            this.quotesfr = data.QuoteFr || data.quotesfr;
        }
    }
}

export class voice {
    language: string;
    id: number;
    active: boolean;
    audioUrl: string;
    audio: string;
    category: number;
    createdOn: string;
    default: boolean;
    imageName: string;
    imageUrl: string;
    title_en: string;
    title_fr: string;
    title_es: string;
    author_en: string;
    author_fr: string;
    author_es: string;
    transcript_en: string;
    transcript_fr: string;
    transcript_es: string;
    updatedOn: string;
    rating: any;
    categoryDetails: any = {};
    seriesType: string;
    courseProgress: any;
    constructor(data?: any, seriesType?: string) {
        this.id = data.ID || data.id;
        this.active = data.Active || data.active;
        this.audioUrl = data.AudioUrl || data.audioUrl;
        this.audio = data.Audio || data.audio;
        this.title_en = data.Title_en || data.title_en;
        this.title_fr = data.Title_fr || data.title_fr || this.title_en;
        this.title_es = data.Title_es || data.title_es || this.title_en;
        this.author_en = data.Author_en || data.author_en;
        this.author_fr = data.Author_fr || data.author_fr || this.author_en;
        this.author_es = data.Author_es || data.author_es || this.author_en;
        this.category = data.Category || data.category || 0;
        this.createdOn = data.CreatedOnUtc || data.createdOnUtc;
        this.default = data.Default || data.default;
        this.imageName = data.Image || data.image;
        this.imageUrl = data.ImageUrl || data.imageUrl;
        this.transcript_en = data.Transcript_en || data.transcript_en;
        this.transcript_fr =
            data.Transcript_fr || data.transcript_fr || this.transcript_en;
        this.transcript_es =
            data.Transcript_es || data.transcript_es || this.transcript_en;
        this.updatedOn = data.UpdatedOnUtc || data.updatedOnUtc;
        this.rating = data.rating || 0;
        this.categoryDetails =
            data.categorydetails || this.categoryDetails || {};
        this.seriesType = seriesType || '';
        this.courseProgress = data.Progress || data.progress || {};
    }
    public static initializeArray(objects: any, seriesType: string): voice[] {
        let results: voice[] = [];
        for (let i = 0; i < objects.length; i++) {
            let obj = new voice(objects[i], seriesType);
            obj.rating = objects[i]?.Rating?.length
                ? +objects[i].Rating[0].Rating
                : 0;
            results.push(obj);
        }

        return results;
    }
}

export class DailySeries {
    id: number;
    bgColor: string = '#AE80E6';
    lightColor: string;
    darkColor: string;
    textColor: string;
    text_en: string;
    text_fr: string;
    text_es: string;
    categoryId: number;
    category: any;
    groupId: number;
    constructor(data: any) {
        if (data) {
            this.id = data.ID || data.id;
            this.categoryId = data.CategoryID || data.categoryId;
            this.groupId = data.GroupID || data.groupId;
            this.category = data.category || data.Category;
            this.text_en = data.QuoteEn || data.title_en;
            this.text_fr = data.QuoteFr || data.title_fr || this.text_en;
            this.text_es = data.QuoteEs || data.title_es || this.text_en;
            this.bgColor = data.BgColor || data.bgColor;
            this.lightColor = UtilityService.getLighterColor(this.bgColor, 30);
            this.darkColor = UtilityService.getDarkerColor(this.bgColor, 30);
            this.textColor = UtilityService.getTextColorBlackOrWhite(
                this.bgColor
            );
        }
    }
    public static initializeArray(data: any): DailySeries[] {
        let results: DailySeries[] = [];
        for (let i = 0; i < data.length; i++) {
            let obj = new DailySeries(data[i]);
            results.push(obj);
        }

        return results;
    }
}
